export enum PartnerType {
    IAB = "IAB",
    Google = "Google",
    Sirdata = "Sirdata"
}

export const PARTNER_TYPES = [PartnerType.IAB, PartnerType.Google, PartnerType.Sirdata];
